var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable react/forbid-prop-types */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */
var React = require("react");
var _ = require("underscore");

var ApiOptions = require("../perseus-api.jsx").Options;
var Changeable = require("../mixins/changeable.jsx");
var GradedGroupEditor = require("./graded-group-editor.jsx");

var GradedGroupSetEditor = React.createClass({
    displayName: "GradedGroupSetEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        apiOptions: ApiOptions.propTypes,
        gradedGroups: React.PropTypes.array,
        onChange: React.PropTypes.func.isRequired
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            gradedGroups: []
        };
    },
    componentWillMount: function componentWillMount() {
        this._editors = [];
    },
    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },
    getSaveWarnings: function getSaveWarnings() {
        var _ref;

        return (_ref = []).concat.apply(_ref, this._editors.map(function (editor) {
            return editor.getSaveWarnings();
        }));
    },
    serialize: function serialize() {
        return {
            gradedGroups: this.props.gradedGroups
        };
    },
    renderGroups: function renderGroups() {
        var _this = this;

        if (!this.props.gradedGroups) {
            return null;
        }
        return this.props.gradedGroups.map(function (group, i) {
            return React.createElement(GradedGroupEditor, _extends({
                key: i,
                ref: function ref(el) {
                    return _this._editors[i] = el;
                }
            }, group, {
                apiOptions: _this.props.apiOptions,
                widgetEnabled: true,
                immutableWidgets: false,
                onChange: function onChange(data) {
                    return _this.change("gradedGroups", setArrayItem(_this.props.gradedGroups, i, _extends({}, _this.props.gradedGroups[i], data)));
                }
            }));
        });
    },
    addGroup: function addGroup() {
        var groups = this.props.gradedGroups || [];
        this.change("gradedGroups", groups.concat([GradedGroupEditor.getDefaultProps()]));
    },
    render: function render() {
        return React.createElement(
            "div",
            { className: "perseus-group-editor" },
            this.renderGroups(),
            React.createElement(
                "button",
                { onClick: this.addGroup },
                "Add group"
            )
        );
    }
});

var setArrayItem = function setArrayItem(list, i, value) {
    return [].concat(list.slice(0, i), [value], list.slice(i + 1));
};

module.exports = GradedGroupSetEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/graded-group-set-editor.jsx
 ** module id = 109
 ** module chunks = 0 1
 **/